import React from 'react'

import womanWithGift from './i/womanWithGift.svg'

import './ExtendSuccess.scss'

const TrialEndedModal = ({ t, onClose }) => {
    return (
        <div className="trial-ended-modal__success">
            <h3>{t('Free trial')}</h3>
            <img src={womanWithGift} alt="" />
            <p>{t('Free period extended for 14 days')}</p>
            <div className="button-container">
                <button className="button" data-variant="primary" data-size="md" onClick={onClose}>
                    {t('Ok!')}
                </button>
            </div>
        </div>
    )
}

export default TrialEndedModal
